import useAppSettingsStore from '@/store/modules/appSettings.js';

const useBackgroundMusicHook = () => {
  const appSettingsStore = useAppSettingsStore();

  const visibilityChangeCallback = () => {
    if (appSettingsStore.isMusicEnabled) {
      if (document.hidden) {
        appSettingsStore.pauseMusic();
      } else {
        appSettingsStore.playMusic();
      }
    }
  };

  const addBackgroundMusicListener = () => {
    document.addEventListener('visibilitychange', visibilityChangeCallback);
  };

  const removeBackgroundMusicListener = () => {
    document.removeEventListener('visibilitychange', visibilityChangeCallback);
  };

  return {
    addBackgroundMusicListener,
    removeBackgroundMusicListener,
  };
};

export default useBackgroundMusicHook;
